module.exports = ":root{--lui-button-minwidth:0px;--lui-button-primary-bg:var(--lui-aqua);--lui-button-primary-text-color:var(--lui-gray);--lui-button-primary-border-color:transparent;--lui-button-secondary-bg:transparent;--lui-button-secondary-text-color:var(--lui-gray);--lui-button-secondary-border-color:var(--lui-gray);--lui-button-tertiary-bg:transparent;--lui-button-tertiary-text-color:var(--lui-darkaqua);--lui-button-tertiary-border-color:transparent}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-button/theme/lui-button.global.scss
// module id = 181
// module chunks = 0 1 18